import { Block } from "@mui/icons-material";
import Box from '@mui/material/Box';
import React, { useEffect } from "react";
import Grid from '@mui/material/Grid';
import {Document,Page,Text,View,StyleSheet,PDFViewer,Font} from "@react-pdf/renderer";
import { Html } from "react-pdf-html";
import Barcode from "react-barcode";
const Idoneita = () =>{

    const styles = StyleSheet.create({
        page: {
          backgroundColor: "white",
          color: "black",
        },
        section: {
          margin: 10,
          padding: 10,
        },
        viewer: {
          width: window.innerWidth, //the pdf viewer will take up all of the width and height
          height: window.innerHeight,
        },
      });

      const tot = [1,2,3]


    let x = "mimmo"


return(
  <>
  
 
  {tot.map(t =>

    <Box sx={{ flexGrow: 1 }}>
    <Grid container spacing={2}>
      <Grid item xs={6}>
       Dr. Veronica D'ambrosio <br/>
       Medico competente <br/>
       Data delle visita : <b>24/06/2022</b>  <br/>
       Società :<b> MyCHef RIstorazione Commerciale S.p.A.</b><br/>
       Dipendente : <b>CARLO DI PAOLO </b><br/>
       Mansione : <b>Operatore PV - Notturno</b> <br />
       Distaccato:
      </Grid>
      <Grid item xs={6} sx={{textAlign:"right"}}>
        <Barcode value="78" format="CODE39" height="40" displayValue={false} width="4"></Barcode>
      
        <h3>GIUDIZIO DI IDONEITA' ALLA MANSIONE</h3>
        Codice Fiscale : <b>DPLCRL89C06Z133A </b> <br/>
        Data di Nascita : <b>06 /03/1989</b>

      </Grid>
      <Grid item xs={12}>
        <table style={{width:"100%"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>movimentazione manuale dei carichi</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>rumore</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>sovraccarico biomeccanico arti superiori</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>campi elettromagnetici</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>agenti chimici</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>radiazioni ottiche artificiali</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>agenti cancerogeni e mutageni</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>radiazioni ultraviolette naturali</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>amianto</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>microclima severo</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>silice libera cristallina</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>infrasuoni</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>agenti biologici</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>ultrasuoni</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>videoterminali</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>atmosfere iperbariche</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>vibrazioni corpo intero</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>lavoro notturno per 80gg l'anno</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>vibrazioni mano/braccio</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>altri rischi evidenziati da V.R.</td></tr>
         
      
        </table>
           {/* Secondo pezzo*/}
        <table style={{border:"1px solid black",width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Visita periodica</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Visita preassuntiva</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Visita a richiesta del lavoratore</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Visita di rientro</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Visita straordinaria</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Flessibilità per maternità</td></tr>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Cambio mansione</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Su richiesta DPI</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Rientro post-Covid</td></tr>
            <tr ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Visita fine missione</td></tr>
            
      
        </table>
          {/* Terzo pezzo*/}
          <table style={{border:"1px solid black",width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"100%",border:"1px solid black"}}>Note Visita<br/><center><hr style={{display:"Block",height:"1px",width:"98%",border:"none",borderTop:"solid 1px black",marginTop:"25px"}}/><hr style={{display:"Block",height:"1px",width:"98%",border:"none",borderTop:"solid 1px black",marginTop:"25px"}}/> </center> </td></tr>
        </table>
              {/* Quarto pezzo*/}
              <table style={{border:"1px solid black",width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"23%",border:"1px solid black"}}>Annuale</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"23%",border:"1px solid black"}}>Biennale</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"23%",border:"1px solid black"}}>Triennale</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"23%",border:"1px solid black"}}>Quinquennale</td></tr>
      
        </table>
         {/* Quinto pezzo*/}
         <table style={{border:"1px solid black",width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"100%",border:"1px solid black"}}>Note Periodicità<br/><center><hr style={{display:"Block",height:"1px",width:"98%",border:"none",borderTop:"solid 1px black",marginTop:"25px"}}/><hr style={{display:"Block",height:"1px",width:"98%",border:"none",borderTop:"solid 1px black",marginTop:"25px"}}/> </center> </td></tr>
        </table>
            {/* Sesto pezzo generabile*/}
            <table style={{width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Visita Generale</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Glicemia</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Tampone Rapido</td></tr>
            <tr style={{width:"100%",border:"1px solid black",visibility:"hidden"}} ><td style={{width:"2%",border:"1px solid black",visibility:"hidden"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>ciao</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>ciao</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>ciao</td></tr>
            <tr style={{width:"100%",border:"1px solid black",visibility:"hidden"}} ><td style={{width:"2%",border:"1px solid black",visibility:"hidden"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>ciao</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>ciao</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>ciao</td></tr>

        </table>
        {/* Settimo pezzo*/}
        <table style={{border:"1px solid black",width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Idoneo</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Non idoneo permanentemente</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"31%",border:"1px solid black"}}>Non idoneo temporaneo</td></tr>
        </table>
        {/* Ottavo pezzo*/}
        <table style={{border:"1px solid black",width:"100%"}}>
        <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>Idoneo con prescrizioni o limitazioni permanenti</td><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"48%",border:"1px solid black"}}>Idoneo con prescrizioni o limitazioni temporanee</td></tr>
        </table>
         {/* Nono pezzo*/}
         <table style={{border:"1px solid black",width:"100%"}}>
        <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"2%",border:"1px solid black"}}><input  type="checkbox"/></td><td style={{width:"98%",border:"1px solid black"}}>IDONEO AI SENSI DEL D.LGS. 131/2003 e del protocollo di intesa GU266/2007 art. 1,2,3 allo svolgimentodi mansioni di cui all'allegato</td></tr>
        </table>
           {/* Decimo pezzo*/}
           <table style={{border:"1px solid black",width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"100%",border:"1px solid black"}}>Note Giudizio<br/><center><hr style={{display:"Block",height:"1px",width:"98%",border:"none",borderTop:"solid 1px black",marginTop:"25px"}}/><hr style={{display:"Block",height:"1px",width:"98%",border:"none",borderTop:"solid 1px black",marginTop:"25px"}}/><hr style={{display:"Block",height:"1px",width:"98%",border:"none",borderTop:"solid 1px black",marginTop:"25px"}}/><hr style={{display:"Block",height:"1px",width:"98%",border:"none",borderTop:"solid 1px black",marginTop:"25px"}}/> </center> </td></tr>
        </table>
           {/* Undicesimo pezzo*/}
           <table style={{border:"1px solid black",width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"100%",border:"1px solid black"}}>Avverso al giudizio di idoneità specifica è ammesso ricorso entro 30gg. all'organo di vigilanza territoriale competente (D.Lgs 81/08, art. 41 comma9). </td></tr>
        </table>
        {/* Dodicesimo pezzo*/}
        <table style={{border:"1px solid black",width:"100%",marginTop:"10px"}}>
            <tr style={{width:"100%",border:"1px solid black"}} ><td style={{width:"100%",border:"1px solid black"}}>CONSENSO SCRITTO AL TRATTAMENTO DEI DATI SANITARI PERSONALI (Art. 13 Legge 196/03). Io sottoscritto esprimo il mio consenso all'archiviazione e al trattamento dei mieti dati sanitari con le seguenti finalità: protezione della salute e della sicurezza e definizione del giudizio di idoneità al lavoro. Confermo che le notizie anamnestiche fornite sono complete e veritiere. Confermo inoltre che sono stato informato dal medico competente sul significato degli accertamenti sanitari a cui sono stato sottoposto e sui risultati degli stessi </td></tr>
        </table>
        <table style={{width:"100%",marginTop:"10px",marginTop:"5px"}}>
            <tr style={{width:"100%"}} ><td style={{width:"50%"}}>Firma del Medico <hr style={{marginTop:"40px",width:"50%",border:"none",borderTop:"solid 1px black"}} /></td> <td style={{width:"50%"}}>Firma del Dipendente <hr style={{marginTop:"40px",width:"50%",border:"none",borderTop:"solid 1px black"}} /></td></tr>
        </table>
      </Grid>
      
    </Grid> 
    <br></br>
    <br></br>
    <br></br>
   
  </Box>

   )}
   
  </>
)









}

export default Idoneita;



/*



  <PDFViewer style={styles.viewer}>
  
    <Document>



      {tot.map(t => {
                  let html = `<body><div><input type="checkbox" checked></div></body>
                `;
            
        return(
      <Page size="A4" style={styles.page}>
            
          <Html>{html}</Html>
          <View style={{flexDirection: "column", width: 400}}>
          <View style={{ flexDirection: "row", marginBottom: 4 }}>
            <Text style={{ marginHorizontal: 8 }}>•</Text>
            <Text>hihihihihihihi</Text>
          </View>
          <View style={{ flexDirection: "row", marginBottom: 4 }}>
            <Text style={{ marginHorizontal: 8 }}>•</Text>
            <Text>11111111111111</Text>
          </View>
          <View style={{ flexDirection: "row", marginBottom: 4 }}>
            <Text style={{ marginHorizontal: 8 }}>•</Text>
            <Text>22222222222222</Text>
          </View>
        </View>
      </Page>
      )}
  )}
    </Document>
  </PDFViewer>


















  /// OK 


  


*/